var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3588_87534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5H1C0.724142 10.5 0.5 10.2759 0.5 10V1C0.5 0.724142 0.724142 0.5 1 0.5H10C10.2759 0.5 10.5 0.724142 10.5 1V10C10.5 10.2759 10.2759 10.5 10 10.5Z",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5H23C23.2759 0.5 23.5 0.724142 23.5 1V10C23.5 10.2759 23.2759 10.5 23 10.5H14C13.7241 10.5 13.5 10.2759 13.5 10V1C13.5 0.724142 13.7241 0.5 14 0.5Z",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 23.5H1C0.724142 23.5 0.5 23.2759 0.5 23V14C0.5 13.7241 0.724142 13.5 1 13.5H10C10.2759 13.5 10.5 13.7241 10.5 14V23C10.5 23.2759 10.2759 23.5 10 23.5Z",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5H23C23.2759 13.5 23.5 13.7241 23.5 14V23C23.5 23.2759 23.2759 23.5 23 23.5H14C13.7241 23.5 13.5 23.2759 13.5 23V14C13.5 13.7241 13.7241 13.5 14 13.5Z",
    stroke: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3588_87534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.53cdb1e41c384dfcc26e8c8cbb771903.svg";
export { ForwardRef as ReactComponent };